/** @format */

import React from 'react';
import { Col, Row, Skeleton } from 'antd';

/**
 * SalesSummarySkeleton Component
 * Loading skeleton that matches the SalesSummary layout
 */
const SalesSummarySkeleton: React.FC = () => {
  // Array of 12 cards to match SalesSummary
  const cards = Array.from({ length: 12 }, (_, i) => i);

  return (
    <div className='dashboard-container'>
      <Row gutter={[28, 28]} className='rates'>
        {cards.map((index) => (
          <Col xs={12} sm={8} md={8} lg={6} xl={6} key={index}>
            <div
              style={{
                backgroundColor: index === 0 ? '#e6f4ff' : index === 3 || index === 7 ? '#f5f0ff' : '#fafafa',
                borderRadius: '8px',
                padding: '16px',
                height: '100%',
                minHeight: '110px',
              }}
            >
              {/* Title skeleton */}
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                <Skeleton.Input
                  active
                  size='small'
                  style={{ width: 120, height: 16 }}
                />
                <Skeleton.Avatar active size='small' shape='circle' style={{ width: 16, height: 16 }} />
              </div>

              {/* Value skeleton */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton.Input
                  active
                  size='large'
                  style={{ width: 80, height: 32 }}
                />
                {/* Trend skeleton - show on most cards */}
                {![1, 2, 7, 10].includes(index) && (
                  <Skeleton.Input
                    active
                    size='small'
                    style={{ width: 50, height: 20 }}
                  />
                )}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SalesSummarySkeleton;
